import { render, staticRenderFns } from "./BookingTabs.vue?vue&type=template&id=16e76255&scoped=true&"
import script from "./BookingTabs.vue?vue&type=script&lang=js&"
export * from "./BookingTabs.vue?vue&type=script&lang=js&"
import style0 from "./BookingTabs.vue?vue&type=style&index=0&id=16e76255&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e76255",
  null
  
)

export default component.exports